<script setup>
defineProps({
  body: { type: String, default: '' },
  header: { type: String, default: '' },
  mediaType: { type: String, default: '' },
  footer: { type: String, default: '' },
  buttons: { type: Array, default: () => [] },
});
const mediaLabels = {
  image: 'Imagem',
  video: 'Vídeo',
  document: 'Documento',
  location: 'Localização',
};
</script>

<template>
  <div
    class="pointer-events-none rounded-xl bg-[#efeae2] p-3 dark:bg-n-solid-3"
  >
    <div
      class="overflow-hidden rounded-lg bg-n-solid-1 text-n-slate-12 shadow-sm"
    >
      <div
        v-if="mediaType && mediaType !== 'text'"
        class="flex min-h-16 items-center justify-center gap-2 bg-n-alpha-2 px-3 py-2 text-xs text-n-slate-11"
      >
        <span class="i-lucide-paperclip size-4" />
        {{ mediaLabels[mediaType] || mediaType }}
      </div>
      <div class="space-y-2 p-3">
        <p
          v-if="header"
          class="m-0 whitespace-pre-wrap break-words text-sm font-semibold line-clamp-2"
        >
          {{ header }}
        </p>
        <p
          class="m-0 whitespace-pre-wrap break-words text-sm leading-5 line-clamp-5"
        >
          {{ body }}
        </p>
        <p
          v-if="footer"
          class="m-0 whitespace-pre-wrap break-words text-xs text-n-slate-11 line-clamp-2"
        >
          {{ footer }}
        </p>
      </div>
      <div
        v-for="(button, index) in buttons"
        :key="index"
        class="flex min-h-9 items-center justify-center gap-1.5 border-t border-n-weak px-2 py-1.5 text-center text-xs font-medium text-n-blue-11"
      >
        <span
          v-if="button.icon"
          :class="button.icon"
          class="size-3.5 shrink-0"
        />
        <span class="break-words line-clamp-2">{{ button.text }}</span>
      </div>
    </div>
  </div>
</template>
